export default __webpack_public_path__ + "static/media/Raleway-Regular.d9219d8a.ttf";